export default "__VITE_ASSET__C0Fauc$W__"